import axios from 'axios';
import { TTP_API_URL } from 'Config';
import { updateSourceToken, throwCatchedError } from 'utils';

var getUsersSettingsSourceToken;

export const getUsersSettings = (token, word, role, organizationId, sourceToken = null) => {
    getUsersSettingsSourceToken = updateSourceToken(getUsersSettingsSourceToken, sourceToken);

    const fields = ['id', 'firstName', 'lastName', 'avatar', 'role', 'paymentAuthorisation']

    let roleGroup = '1';
    if(role && role !== "ALL") {
        roleGroup = role.slice(0,1);
        role = role.slice(1);
    }

    let requestUrl = `${TTP_API_URL}/organization/user${(roleGroup==2)?'':'/payment-authorisation'}`;
    let filter = [];

    if(roleGroup == '2') {
        filter.push({
            property: 'role.type',
            value: role,
            operator: 'eq'
        });
        filter.push({
            property: 'role.organization',
            value: organizationId,
            operator: 'eq'
        });
    } else {
        if(role && role !== "ALL") {
            requestUrl += '?paymentRole=' + role;
        }
    }
    if(word !== '' && word.length >= 3) {
        filter.push({
            property: 'name',
            value: word,
            operator: 'like'
        });
    }

    let params = {
        access_token: token,
        filter: JSON.stringify(filter),
        fields: fields.join(','),
        limit: 100,
        organization_id: organizationId
    }

    return axios.get(requestUrl, {
        cancelToken: getUsersSettingsSourceToken.token, params
    }).catch(function(thrown) {
        throwCatchedError(thrown)
    });
};

export const saveUsersSettings = (token, role, usersIds, clientId, allowShowOrganizationBalance) => {

  if(role == "____") {

    return deleteUsersSettings(token, role, usersIds, clientId)
  }
    const requestUrl = `${TTP_API_URL}/billing/billing-authorisation/multi-save?access_token=${token}`;
    var formData = new FormData();
    for( let userId of usersIds) {
        formData.append('users_id[]', userId);
    }
    formData.append('issuer_id', clientId);
    formData.append('role', role);
    formData.append('preferences[allowShowOrganizationBalance]', allowShowOrganizationBalance);

  return axios.post(requestUrl, formData);
}

export const deleteUsersSettings = (token, role, usersIds, clientId) => {
  const requestUrl = `${TTP_API_URL}/billing/billing-authorisation/multi-delete?access_token=${token}`;
  var formData = new FormData();
  for( let userId of usersIds) {
    formData.append('users_id[]', userId);
  }
  formData.append('issuer_id', clientId);
  return axios.post(requestUrl, formData);
}



// WEBPACK FOOTER //
// ./app/api/TamtamAPI/user.js